import { render, staticRenderFns } from "./orderCenter.vue?vue&type=template&id=f0229e7e&scoped=true"
import script from "./orderCenter.vue?vue&type=script&lang=js"
export * from "./orderCenter.vue?vue&type=script&lang=js"
import style0 from "./orderCenter.vue?vue&type=style&index=0&id=f0229e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0229e7e",
  null
  
)

export default component.exports